module.exports = new __parcel__URL__("jpd-portfolio-management-intake.e5d5c157.svg").toString();